module.exports = __webpack_public_path__ + "img/s2-1.f24c21f7.svg";